var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"https://seqwens.com/"}},[_c('img',{staticClass:"img-fluid p-2",staticStyle:{"display":"block","margin-left":"auto","margin-right":"auto","height":"65px"},attrs:{"src":_vm.headerLogo,"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }